export const BASE_URL_SANCTUM = '/sanctum/csrf-cookie';
export const BASE_ARES_URL = '/api/v1/ares/';
export const BASE_ORDER_URL = '/api/v1/orders';
export const BASE_CUSTOM_PAYMENT_URL = '/api/v1/custom-payments';
export const BASE_CONSENT_URL = '/api/v1/consent';
export const BASE_PURCHASE_TO_DATA_LAYER_URL =
  '/api/v1/send-purchase-to-data-layer';
export const ORDER_TTL = 60; //in minutes
export const EUR = 'eur';
export const CZK = 'czk';
export const FROM_TWO_WITHOUT_FIRST = 'from_two_without_first';
export const FROM_THREE_ATTENDEES = 'from_three_attendees';
export const NO_DISCOUNT = 'no_discount';
export const CARD_PAYMENT = 'card';
export const RECAPTCHA_SITE_KEY = process.env.MIX_RECAPTCHA_SITE_KEY;
